import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import NewRelease from 'components/pages/NewRelease'

import {
  selectEnvironment,
  selectIsMaster,
  selectLastProductRelease,
  selectLastSeenProductRelease,
} from '../App/selectors'

import * as newReleaseActions from './actions'

const mapDispatchToProps = (dispatch) => bindActionCreators(newReleaseActions, dispatch)
const mapStateToProps = (state) => ({
  isMaster: selectIsMaster(state),
  lastProductRelease: selectLastProductRelease(state),
  lastSeenProductRelease: selectLastSeenProductRelease(state),
  environment: selectEnvironment(state),
})

const render = connect(mapStateToProps, mapDispatchToProps)(NewRelease)

export default withRouter(render)
